import React, { useState } from 'react';
import { Select, Typography, Button } from 'antd';
import { useSession } from 'next-auth/react';
import GeneratedAssetsInventory from './GeneratedAssetsInventory';
import styles from './3d-generation.module.css';
import ShutterstockGeneration from './ShutterstockGeneration';
import Tripo3DGeneration from './Tripo3DGeneration';

const { Option } = Select;
const { Text } = Typography;

type GenerationBackend = 'shutterstock' | 'tripo3d';

const ThreeDGeneration: React.FC<{
  addToScene: (data: any) => void;
}> = ({ addToScene }) => {
  const session = useSession();
  const [isInventoryOpen, setIsInventoryOpen] = useState(false);
  const [selectedBackend, setSelectedBackend] =
    useState<GenerationBackend>('shutterstock');

  const handleBackendChange = (value: GenerationBackend) => {
    setSelectedBackend(value);
  };

  return (
    <div className={styles.root}>
      <div>
        <h4 className={styles.title}>Generated Assets:</h4>
        <Button
          type='primary'
          onClick={() => setIsInventoryOpen(true)}
          className={styles.inventoryButton}
        >
          Open Inventory
        </Button>
      </div>
      <span className={styles.title}>3D Model Generator</span>
      <div className={styles.backendSelector}>
        <Text strong>Generation Backend:</Text>
        <Select
          value={selectedBackend}
          onChange={handleBackendChange}
          style={{ width: '100%', marginTop: 8 }}
        >
          <Option value='shutterstock'>Shutterstock</Option>
          <Option value='tripo3d'>Tripo3D AI</Option>
        </Select>
      </div>

      {selectedBackend === 'shutterstock' ? (
        <ShutterstockGeneration addToScene={addToScene} />
      ) : (
        <Tripo3DGeneration addToScene={addToScene} />
      )}
      <GeneratedAssetsInventory
        isOpen={isInventoryOpen}
        addToScene={addToScene}
        setIsOpen={setIsInventoryOpen}
        userId={session.data?.user?.id}
      />
    </div>
  );
};

export default ThreeDGeneration;
